import type { IGSplatNode } from './LODTypes'
import type { IGSplatResource } from './ResourceTypes'

/**
 * 资源接口（支持引用计数）
 */
export interface IGSplatResourceWithRefCount extends IGSplatResource {
  /** 增加引用计数 */
  incRefCount(): void
  /** 减少引用计数，归零时应当由调用方触发释放 */
  decRefCount(): void
}

/**
 * 类型守卫：判断资源是否支持引用计数。
 *
 * @param resource - 待检测的资源
 * @returns 同时暴露 incRefCount/decRefCount 时返回 true
 */
export function hasRefCounting(resource: IGSplatResource): resource is IGSplatResourceWithRefCount {
  const res = resource as unknown as Partial<IGSplatResourceWithRefCount>
  return (
    'incRefCount' in resource &&
    typeof res.incRefCount === 'function' &&
    'decRefCount' in resource &&
    typeof res.decRefCount === 'function'
  )
}

/**
 * 节点接口（包含几何体属性）
 * 扩展 IGSplatNode 以兼容现有代码
 */
export interface INodeWithGeometry extends IGSplatNode {
  /** 节点携带的几何体，具体类型由实现决定 */
  geometry?: unknown
}

/**
 * 类型守卫：判断节点是否携带几何体。
 *
 * @param node - 待检测节点
 * @returns 含 geometry 字段时返回 true
 */
export function hasGeometry(node: IGSplatNode): node is INodeWithGeometry {
  return 'geometry' in node
}
